export const nlToBr = (text: string) => text.replace(/\n/gm, "<br/>");
